import React from 'react'
import PersistedComponent from '../../PersistedComponent'
import MobileArticleImageBox from '../../../boxes/StyledMobileArticleImageBox'
import WidgetContainer from '../../../containers/WidgetContainer'
import { ImageRow } from '../../../utils/Grid'
import MobileBoxesGenerator from '../../../utils/MobileBoxesGenerator'
import ImageBoxWrapper from '../ImageBoxWrapper'
import { type ArticlesWidgetProps } from '../Types'

export default class MobileArticles extends PersistedComponent<ArticlesWidgetProps> {
  constructor (props: ArticlesWidgetProps) {
    super(props)

    this.persistedKeys.push('isOpen')

    this.state = Object.assign({ isOpen: true }, this.state)
  }

  handleToggleContent () {
    const {
      isOpen
    } = this.state

    this.setState({
      isOpen: !isOpen
    })
  }

  render () {
    const {
      props: {
        activeDynamicLayout,
        isOpening,
        widget,
        widget: {
          ad,
          boxes,
          imageSize,
          name,
          utmContent,
          utmMedium,
          utmSource
        },
        renderAdditionalComponent
      },
      state: {
        isOpen
      }
    } = this

    const utmParams = {
      utmContent,
      utmMedium,
      utmSource
    }

    const renderImageBox = (box, index) => <ImageBoxWrapper
      box={box}
      imageBoxComponent={MobileArticleImageBox}
      imageSize={imageSize}
      index={index}
      key={`mobileArticlesBox${index}`}
      utmParams={utmParams}
    />

    return (
      <WidgetContainer
        activeDynamicLayout={activeDynamicLayout}
        handleToggleContent={this.handleToggleContent.bind(this)}
        isOpen={isOpen}
        isOpening={isOpening}
        widget={widget}
      >
        { renderAdditionalComponent && renderAdditionalComponent() }
        <ImageRow>
          <MobileBoxesGenerator
            ad={ad}
            boxes={boxes}
            device={activeDynamicLayout}
            name={name}
            renderImageBox={renderImageBox}
          />
        </ImageRow>
      </WidgetContainer>
    )
  }
}
